import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

// Two-frame ASCII payoff diagram — ov-payoff-a/b blink via index.css

const FRAME_A =
`  P&L
   │         ╱
   │        ╱
   │       ╱
   │──────╱──── spot
   │`;

const FRAME_B =
`  P&L
   │
   │
   │
   │──────────── spot
   │`;

export default function NotFound() {
  return (
    <>
      <SEOHead title="404 — Strike not found" canonicalPath="/404" />

      <div className="max-w-lg mx-auto px-4 py-24 text-center">
        {/* Animated payoff diagram */}
        <div className="inline-block mb-8 text-left">
          <div className="relative font-mono text-sm leading-5 text-green-400 dark:text-green-500">
            <pre className="whitespace-pre ov-payoff-a">{FRAME_A}</pre>
            <pre className="absolute top-0 left-0 whitespace-pre ov-payoff-b">{FRAME_B}</pre>
          </div>
          <p className="mt-3 font-mono text-xs text-neutral-400 dark:text-neutral-500 text-center">
            strike not found
          </p>
        </div>

        <p className="text-5xl font-bold text-neutral-900 dark:text-neutral-100 mb-3">404</p>
        <p className="text-neutral-500 dark:text-neutral-400 mb-8">
          This page doesn't exist.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-clay-sm bg-primary-600 hover:bg-primary-700 text-white text-sm font-medium shadow-clay-btn transition-colors"
        >
          ← Back to home
        </Link>
      </div>
    </>
  );
}
